import { axiosInstance } from "../helpers/request";
import type { BillingOperationSummary } from "../types/billing";

class OperationApi {
  list(streamId: string) {
    return axiosInstance.get<BillingOperationSummary[]>(`/live-stream/${streamId}/operations`);
  }

  retry(streamId: string, operationId: string) {
    return axiosInstance.post<BillingOperationSummary>(
      `/live-stream/${streamId}/operations/${operationId}/retry`
    );
  }
}

const operationApiInstance = new OperationApi();
export default operationApiInstance;
